import { errorsInitState } from '@/utils'

const state = errorsInitState()

const actions = {

}

const mutations = {
    SET_LOGIN_ERROR(state, error) {
        state.login = error
    },
    RESET_LOGIN_ERROR(state) {
        state.login = null
    },
    SET_SIGNUP_ERROR(state, data) {
        const errors = []
        Object.keys(data).forEach(key => {
            errors.push({ field: key, error: data[key][0] })
        })
        state.signup = errors
    },
    RESET_SIGNUP_ERROR(state) {
        state.signup = null
    },
    SET_CREATE_EVENT_ERROR(state, error) {
        state.createEvent = error
    },
    RESET_CREATE_EVENT_ERROR(state) {
        state.createEvent = null
    },
    RESET_STATE(state) {
        Object.assign(state, errorsInitState())
    }
}

export default {
    state,
    actions,
    mutations
}